import PageNewRegistration from "./RegistrationPageNew";
export default PageNewRegistration